/**
 * Fiche Lunetterie du Russey (téléconsultation / prises de rendez-vous)
 */
export const DOCTOLIB_LUNETTERIE_RUSSEY =
  'https://www.doctolib.fr/magasin-d-optique/le-russey/lunetterie-du-russey?pid=practice-761183&phs=true&page=1';

/** Réservation — adaptation de lentilles (motive) */
export const DOCTOLIB_RUSSEY_ADAPTATION_LENTILLES =
  'https://www.doctolib.fr/magasin-d-optique/le-russey/lunetterie-du-russey/booking/availabilities?specialityId=13512&telehealth=false&placeId=practice-761183&motiveIds%5B%5D=15742878&pid=practice-761183&source=profile';

/** Réservation — consultation vidéo (motive) */
export const DOCTOLIB_RUSSEY_CONSULTATION_VIDEO =
  'https://www.doctolib.fr/magasin-d-optique/le-russey/lunetterie-du-russey/booking/availabilities?specialityId=13512&telehealth=false&placeId=practice-761183&motiveIds%5B%5D=15466506&pid=practice-761183&source=profile';

/** Réservation — examen de vue (motive) */
export const DOCTOLIB_RUSSEY_EXAMEN_VUE =
  'https://www.doctolib.fr/magasin-d-optique/le-russey/lunetterie-du-russey/booking/availabilities?specialityId=13512&telehealth=false&placeId=practice-761183&motiveIds%5B%5D=15742873&pid=practice-761183&source=profile';

export const DOCTOLIB_OPHTALMO_BESANCON =
  'https://www.doctolib.fr/search?keyword=ophtalmologue&location=besancon';

/**
 * Renouvellement d'ordonnance (ordonnance expirée) : 16-75 ans → parcours au Russey ; sinon Besançon
 */
export function doctolibRenewalByAge(currentAge) {
  const n = Math.floor(Number(currentAge));
  if (n >= 16 && n <= 75) {
    return {
      href: DOCTOLIB_LUNETTERIE_RUSSEY,
      label: 'Prendre rendez-vous au Russey (Doctolib)',
    };
  }
  return {
    href: DOCTOLIB_OPHTALMO_BESANCON,
    label: 'Prendre rendez-vous ophtalmologue (Besançon, Doctolib)',
  };
}
